import instance from "../../shared/utils/instance";

export const getInstructionsApi = (rootEntityId) => {
  return instance.get(`/instructions-by-rootEntity/${rootEntityId}`);
};
